/* global MessengerExtensions */
import defer from "./defer";

let sdkInitializing;
let [$sdk, resolveSdk] = defer();

export function sdkIsReady() {
  if (!sdkInitializing && !window.MessengerExtensions) {
    sdkInitializing = true;
    try {
      initSdk();
      window.extAsyncInit = function() {
        sdkInitializing = false;
        resolveSdk(window.MessengerExtensions);
      };
    } catch (err) {
      console.log(err);
      sdkInitializing = false;
    }
  }

  return $sdk;
}

export function getContext(appId) {
  return new Promise((res, rej) => {
    MessengerExtensions.getContext(appId, res, rej);
  });
}

export function closeWebviewFb() {
  return new Promise((res, rej) => {
    MessengerExtensions.requestCloseBrowser(res, rej);
  });
}

export function dotFlowCallbackFb(id, text) {
  return fetch(`${process.env.REACT_APP_DOTFLOW}/fb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      entry: [
        {
          messaging: [
            {
              sender: { id },
              message: { text }
            }
          ]
        }
      ]
    })
  });
}

function initSdk() {
  /* eslint-disable */
  (function(d, s, id) {
    let js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.com/en_US/messenger.Extensions.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "Messenger");
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/utils/facebookWebview.js